;(function($, undefined){
    var rnn, log, maps,
        loginForm = '';

    function initRecurrencePopup() {
        var $recurringDateDiv = $(".futureEventDates");
        if ($recurringDateDiv.length) {
            $(document).on('click', function(event){
                var $target = $(event.target);
                //clicked in the dropdown - nada
                if ($target.closest(".futureEventDates").length){
                    return;
                }
                //clicked elsewhere when it's open - hide
                if ($recurringDateDiv.is(":visible")) {
                    $recurringDateDiv.stop(true).slideUp();
                    //clicked the show link
                } else if($target.closest(".eventDate.recurring button").length){
                    $recurringDateDiv.stop(true).slideDown();
                    event.preventDefault();
                }
            });
        }
    }

    function initContentUploadExpanders() {
        var triggerBtns = $(".uploadButtonBar .action");

        $(triggerBtns).toggle(
            function (event) {
                var thisUploadFormWrapper = $(event.target).parent().siblings(".uploaderForm");
                thisUploadFormWrapper.stop().slideDown('fast');
                event.preventDefault();
            },
            function (event) {
                var thisUploadFormWrapper = $(event.target).parent().siblings(".uploaderForm");
                thisUploadFormWrapper.stop().slideUp('fast');
                event.preventDefault();
            }
        );
    }

    function rsvpAjax(options){
        options = $.extend(true, {
            url: 'rsvp/',
            dataType: 'json'
        }, options);

        $.ajax(options);
    }

    function sendRSVP($rsvpButton) {
        var $rsvpWidget = $rsvpButton.closest('[data-event-time-id]'),
            attending = $rsvpButton.val(),
            eventTimeId = $rsvpWidget.data('event-time-id');

        // Ask very nicely to RSVP to the event
        rsvpAjax({
            data: {
                attending: attending,
                event_time_id: eventTimeId
            },
            type: 'POST',
            success: function(data) {
                /*
                 * Update any widgets for this event time. There are multiple
                 * widgets for the next occurrence because it's shown in the
                 * top-right of the page and also in the "more dates" dropdown
                 * list.
                 */

                var $widgets = $('[data-event-time-id=' + eventTimeId + ']'),
                    $attendanceNumber = $widgets.find('.numAttend'),
                    $tagLine = $widgets.find('.tagline'),
                    rsvpData = {};

                // Update the count and text.
                $attendanceNumber.text(data.numberAttendingEventTime);
                $tagLine.text(data.numberAttendingEventTime == 1 && "person attending" ||  "people attending");

                // Update the button states.
                rsvpData[eventTimeId] = (attending == 'yes' ? true : false);
                updateRSVPButtons(rsvpData);
            }
        });
    }

    function updateRSVPButtons(rsvpData){
        for (var eventTimeID in rsvpData) {

            var attending = rsvpData[eventTimeID];

            if (attending !== null) {

                var attendingValue = attending ? 'yes' : 'no',
                    $rsvpWidget = $('[data-event-time-id=' + eventTimeID + ']');

                $rsvpWidget.find('[value="'+attendingValue+'"]').addClass('active').siblings().removeClass('active');
            }
        }
    }

    ////////////////////////////////////////////
    // Call once we have authenticated user
    /////////////////////////////////////////
    function updateWithAjax() {
        rsvpAjax({
            type: 'GET',
            success: function(rsvpData) {
                updateRSVPButtons(rsvpData);
            }
        });
    }

    function initRSVP() {
        var $rsvpWidgets = $('[data-event-time-id]');

        //TODO: this bit is great to update the users's previous
        //attendence state, but the number attending wont get updated
        //from what was already in the page (and that might be old).
        rnn.modules.user.get(function(user){
            if($rsvpWidgets.length && user.authenticated){
                updateWithAjax();
            }
        });

        $rsvpWidgets.each(function(){
            var $rsvpWidget = $(this);

            $rsvpWidget.on('click', '.btn', function(event){
                var $btn = $(event.target).closest('.btn');
                if (!($btn.is(".loginBtn"))) {
                    (!$btn.is('.active')) && sendRSVP($btn);
                    $btn.addClass('active').siblings().removeClass('active');
                } else {
                    rnn.modules.login.loginDisplay("event", "Log in to RSVP to this event");
                }
            });
        });

    }

    function initEditForms() {
        $('.eventsEditForm').each(function () {
            var $field = $(this).find('#id_t-dates');

            if ($field.length) {
                new rnn.modules.MultiDatePicker($field);
            }
        });
    }

    function initOpenWindow(){
        $(document).on('click', '.show_full_tc', function() {
            var width = 720,
                height = 500,
                left = (window.screen.width - width) / 2,
                top = (window.screen.height - height) / 2,
                data = "toolbar=yes, scrollbars=yes, resizable=yes, top="+ top +", left="+ left +", width="+ width +", height=" + height + "\"";
            window.open($(this).attr("href"),"",data);

            return false;
        });
    }

    function initModalMaps() {
        if ($('#eventsDetailMapModal').length) {
            $('#viewFullMap').on('click', function (e) {
                /*
                this should be done on the modal shown event but for some
                reason it never fires
                */
                setTimeout(function () {
                    maps.createDetailMap('eventDetailMap');
                }, 750);
            });
        }
    }

    // Initialise Events
    function initEvents() {

        $('.eventsDetails .showMore').click(function() {
            $('.contentPreview').removeClass('collapsed');
            $(this).hide();
        });

        $('.eventsEditForm button[type="submit"]').click(function()
            { grecaptcha.execute();
            return false;
        });

        initRecurrencePopup();
        initContentUploadExpanders();
        initRSVP();
        initEditForms();
        initOpenWindow();
        initModalMaps();
    }

    rnn = window.rnn;

    log = rnn.logging.log;

    maps = rnn.modules.maps;

    rnn.modules.register('events', {
        init: initEvents,
        updateWithAjax: updateWithAjax
    });

})(jQuery);
